export default __webpack_public_path__ + "static/mixerfi-6de694c669162bb0015f28fe287a9275.png";